import { React, useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useNotification } from "@cisco/spaces-dash-app-business-hierarchy";
import { MSpinner } from "@cisco/spaces-dash-lib-styleguide";
import useLoader from "../../hooks/useLoader";
import { PropertiesContext } from "../../contexts/propertiesContext";
import * as PartnerHomeService from "../../service/partner-dashboard-service";
import { I18nContext } from "../../contexts/i18nContext";

function OauthValidation(props) {
  const i18n = useContext(I18nContext);
  const { setToastMessage } = useNotification();
  useLoader();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { properties } = useContext(PropertiesContext);
  let timer = null;

  const tenantId = sessionStorage.getItem("tenantId");

  const navigateToHome = () => {
    timer = setTimeout(() => {
      navigate(`/partner/sandbox/home`);
    }, 2000);
  };

  useEffect(() => {
    if (!properties.partnerSandboxBaseUrl) return;

    const oAuthCode = searchParams.get("code");
    let state = searchParams.get("state");
    const oauthStateStr = sessionStorage.getItem("state");
    const oauthState = JSON.parse(oauthStateStr);
    console.log(props);
    if (oauthState && oauthState[state] !== null && oauthState[state] !== undefined) {
      state = oauthState[state];
    } else {
      setToastMessage(i18n.t("partner-dashboard-app.auth.activate-appuser.error-occurred-try-again-msg"), 4000, "negative");
      console.log("ERROR: Failed to fetch state from partner");
      navigateToHome();
      return;
    }

    const decodeState = atob(state);
    const decodeStateArray = decodeState.split(",");
    const appId = decodeStateArray[2];
    let locationIds = [];
    let bleGroups = [];
    let acceptedPermissions = [];
    if (decodeStateArray[4]) {
      locationIds = decodeStateArray[4].split("~");
    }
    if (decodeStateArray[6] && decodeStateArray[6].length > 0) {
      bleGroups = decodeStateArray[6].split("~");
    }
    if (decodeStateArray[7] && decodeStateArray[7].length > 0) {
      acceptedPermissions = decodeStateArray[7].split("~");
    }
    let action = "update";
    if (decodeStateArray[5] !== undefined || decodeStateArray[5] !== null) {
      action = decodeStateArray[5] === "true" ? "create" : "update";
    }

    if (properties) {
      const rediectUrl = properties.partnerSandboxBaseUrl + properties.partnerOauthRedirectionUri;

      // PartnerHomeService.getAppStrapiDetails(appId)
      PartnerHomeService.getAppDetails(appId)
        .then((data) => {
          if (data.status && data.data) {
            const partnerApp = data.data;
            console.log(`***** selectedPartnerApp *******${partnerApp}`);
            let config = partnerApp.appTile;
            if (partnerApp.partnerTenantId == tenantId) {
              config = partnerApp.draftConfig.appTile;
            }

            if (config !== null && config.redirectUri !== null && config.clientId !== null && config.clientSecret !== null && config.oAuth === true) {
              // const { clientId } = config;
              // const { clientSecret } = config;
              // const oAuthTokenUrl = config.oAuthTokenURL;
              const { partnerAppInfoURL } = config;
              console.log("App details in partner app oauth : ", data);
              const oathObj = {
                appId,
                code: oAuthCode,
                state,
                redirect_uri: rediectUrl
              };

              PartnerHomeService.getOauthAccessToken(oathObj)
                .then((oauthData) => {
                  if (oauthData.status && oauthData.data) {
                    const accessToken = oauthData.data.access_token;
                    const oAuthConfig = {
                      accessToken: oauthData.data.access_token,
                      partnerTenantId: oauthData.data.scope ? oauthData.data.scope : null,
                      appId,
                      partnerAppInfoURL
                    };
                    PartnerHomeService.getOauthCustomerDetails(oAuthConfig)
                      .then((customerData) => {
                        if (customerData.status && customerData.data) {
                          console.log("Partner apps get customer info response : ", customerData);
                          const subscription = partnerApp.subscriptions[0].name;
                          const { partnerTenantId: rpartnerTenantId } = customerData.data;

                          const application = {
                            partnerTenantId: rpartnerTenantId.toString(),
                            appId,
                            subscription,
                            locationIds,
                            action,
                            iotGroupFilters: bleGroups,
                            acceptedPermissions
                          };

                          if (bleGroups.length === 0) delete application.iotGroupFilters;

                          const partnerCustomerInfo = {
                            appId,
                            accessToken,
                            userEmail: customerData.data.userEmail,
                            supportEmail: customerData.data.supportEmail,
                            partnerTenantId: rpartnerTenantId.toString()
                          };
                          console.log("**** partnerCustomerInfo *****", partnerCustomerInfo);
                          PartnerHomeService.activatePartnerApp(application)
                            .then((activationData) => {
                              if (activationData.status && activationData.data) {
                                console.log("Partner apps activated info response : ", activationData);
                                PartnerHomeService.savePartnerCustomerInformation(partnerCustomerInfo)
                                  .then((partnerCustomerInformationData) => {
                                    if (partnerCustomerInformationData.status && partnerCustomerInformationData.data) {
                                      console.log("Activated Apps Customer info response : ", partnerCustomerInformationData);
                                      setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.app-activation-successfully-msg"), 5000, "positive");
                                      navigateToHome();
                                    } else {
                                      console.log("ERROR: Failed to save activated apps customer info :", partnerCustomerInformationData);
                                      setToastMessage(
                                        i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-save-activated-apps-customer-info-msg"),
                                        4000,
                                        "negative"
                                      );
                                      navigateToHome();
                                    }
                                  })
                                  .catch((error) => {
                                    console.log("ERROR: Failed to save activated apps customer infos :", error);
                                    setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-save-activated-apps-customer-info-msg"), 4000, "negative");
                                    navigateToHome();
                                  });
                              } else {
                                console.log("ERROR: Failed to activate partner apps :", activationData);
                                setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-activate-partner-apps-info-msg"), 4000, "negative");
                                navigateToHome();
                              }
                            })
                            .catch((error) => {
                              console.log("ERROR: Failed to activate partner apps info :", error);
                              setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-activate-partner-apps-info-msg"), 4000, "negative");
                              navigateToHome();
                            });
                        } else {
                          console.log("ERROR: Failed to fetch partner apps customer info :", customerData);
                          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-fetch-partner-apps-customer-info-msg"), 4000, "negative");
                          navigateToHome();
                        }
                      })
                      .catch((error) => {
                        console.log("ERROR: Failed to fetch partner apps customer info :", error);
                        setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-fetch-partner-apps-customer-info-msg"), 4000, "negative");
                        navigateToHome();
                      });
                  } else {
                    console.log("ERROR: Failed to fetch partner apps outh token", oauthData);
                    setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-fetch-partner-apps-oauth-token-msg"), 4000, "negative");
                    navigateToHome();
                  }
                })
                .catch((error) => {
                  console.error(`ERROR: Failed to fetch partner app details. ${error}`);
                  setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-fetch-partner-app-details-msg"), 4000, "negative");
                  navigateToHome();
                });
            } else {
              console.error(`ERROR: Failed to configure the OAuth in Partner Apps Dashboard.`);
              setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-configure-oauth-partner-apps-dashboard-msg"), 4000, "negative");
              navigateToHome();
            }
          }
        })
        .catch((error) => {
          console.error(`ERROR: Failed to fetch partner app details. ${error}`);
          setToastMessage(i18n.t("partner-dashboard-app.partner-apps.partner-app-oauth-validation.error-failed-to-fetch-partner-app-details-msg"), 4000, "negative");
          navigateToHome();
        });
    }
  }, [properties]);

  useEffect(() => {
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div style={{ padding: "40px" }}>
      <div>Validating Oauth...</div>
      <div className="apps-loader">
        <MSpinner size="md" />
      </div>
    </div>
  );
}

export default OauthValidation;
